import Vue from 'vue'
import Vuex from 'vuex'

import category from './category'
import product from './product'
import modal from './modal'
import onlineOrder from './onlineOrder'
import user from './user'
import users from './users'
import settings from './settings'
import sale from './sale'
import info from './info'
import workingShift from './workingShift'
import cashOperation from './cashOperation'
import statistic from './statistic'
import history from './history'
import repair from './repair'
import repairCashOperation from './repairCashOperation'
import config from './config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    category,
    product,
    modal,
    onlineOrder,
    user,
    users,
    settings,
    sale,
    info,
    workingShift,
    cashOperation,
    statistic,
    history,
    repair,
    repairCashOperation,
    config
  }
})


